const firebaseConfig = {
    apiKey: "AIzaSyDz3UnV8c13nItVBU2V1VOCNmvsTxyiTg0",
    authDomain: "sb-tours-and-travels-agency.firebaseapp.com",
    projectId: "sb-tours-and-travels-agency",
    storageBucket: "sb-tours-and-travels-agency.appspot.com",
    messagingSenderId: "601406854440",
    appId: "1:601406854440:web:6ec76f7dc9b0deb7656c1d"
};

export default firebaseConfig;
